<template>
  <div class="editions">
    <b-container fluid="xxl">
      <b-row class="text-center">
        <b-col>
          <input
            class="px-2 py-1 w-100"
            id="search"
            type="text"
            size="sm"
            placeholder="Search editions"
            @keyup="getSearchResults()"
            autocomplete="off"
            v-model="query"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <ul v-if="editions.length" class="results-ul">
            <li v-for="edition in editions" :key="edition.id">
              <a href="#" @click="selectEdition($event, edition)" v-html="edition.sigleLegam"></a>
            </li>
          </ul>
          <span v-else class="opacity-60">
            <span v-if="query">No results</span>
            <span v-else>Start searching</span>
          </span>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'EditionAutocomplete',
    props: ['exclude'],
    data() {
      this.$store.state.edition.editions = []
      return {
        query: '',
        timer: null
      }
    },
    mounted() {
      this.$store.state.edition.editions = []
    },
    computed: {
      ...mapState({
        editions: state => state.edition.editions
      }),
      clearQuery(){
        return this.query.replace(/\*/gi, '')
      }
    },
    methods: {
      selectEdition(event, edition){
        event.preventDefault()
        this.$emit('select', edition)
        this.$store.state.edition.editions = []
        this.query = ''
      },
      getSearchResults(){
        clearTimeout(this.timer)
        // let that = this
        this.timer = setTimeout(() => {
          this.$store.dispatch('searchEditions', {
            query: this.query.toLowerCase(),
            exclude: (this.exclude ? this.exclude : [])
          })
        }, 400)
      }
    }
  }
</script>
